import css from './deVerbValue.module.scss';

import { memo, Fragment } from 'react';

import DisplayTemplate from 'core/ui/DisplayTemplate';

type TProps = {
  value: string;
  showAnswer: boolean;
};
type TGroup = { text: string; pre: string };

const parseTemplate = (value: string, ignoreWithoutPrefix: boolean): TGroup[] =>
  value
    .split('|')
    .map((pair): TGroup => {
      if (!pair.includes(':')) {
        return { pre: '', text: pair };
      }

      const [pre, text] = pair.split(':');
      return { pre: pre.trim(), text: text.trim() };
    })
    .filter(item => !ignoreWithoutPrefix || item.pre.length > 0);

const VerbGrid = ({ value, showAnswer }: TProps) => {
  const data = parseTemplate(value, !showAnswer);

  return (
    <div className={css.groups}>
      {data.map(pair => (
        <Fragment key={pair.pre + pair.text}>
          <div className={css.pre}>{pair.pre}</div>
          <div className={css.text}>
            {showAnswer ? <DisplayTemplate children={pair.text} /> : '?'}
          </div>
        </Fragment>
      ))}
    </div>
  );
};

export default memo(VerbGrid);
